import React from 'react';
import { useParams } from 'react-router-dom';
import { useFieldHelper } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { DeleteButton } from 'framework/ui/ui-builder';
import { EXPENSE_STATUSES, REJECT_EXPENSE, useExpenseService } from 'domain/shared/expense';

const CancelExpenseButton = ({ statusSource }: { statusSource: string }) => {
  const { id } = useParams<Dictionary<string>>();
  const { cancelExpense, invalidateCache } = useExpenseService();
  const { getValue } = useFieldHelper({ source: statusSource });
  const { setData = () => {} } = useShowContext();
  const status = getValue();

  if (status !== EXPENSE_STATUSES.PAID) {
    return null;
  }

  return (
    <DeleteButton
      displayMessage="Do you really want to cancel this payment?"
      deleteMethod={() => cancelExpense(id!)}
      afterDelete={{
        successMessage: 'The Payment has been successfully canceled.',
        errorMessage: "Can't cancel Payment.",
        execute: (data: any) => {
          invalidateCache();
          setData(data);
        },
      }}
      permissionToCheck={REJECT_EXPENSE}
      buttonText="Cancel payment"
      color="error"
    />
  );
};

export default CancelExpenseButton;
